/* eslint-disable @typescript-eslint/no-explicit-any */
import { BRAND_COLOURS } from "utils/constants";

import {
  createDataArray,
  createMonthLabels,
  MonthlyData,
} from "../MonthlyUsageChart/MonthlyUsageChart.utils";

const Y_AXIS_DISPLAY_TYPE = {
  cost: "$",
  usage: "kWh",
};

/**
 * @description Takes the processed data for this year, and the displayType.
 * @returns The max Y value
 */
export const getSolarMaxYValue = (
  thisYearData: MonthlyData[],
  displayType: string,
) => {
  const thisYearSpendConsumptionTotals =
    thisYearData.length > 0
      ? thisYearData.map((item) =>
          displayType === "cost" ? item.spend : item.consumption,
        )
      : [];

  const thisYearEarnedGenerationTotals =
    thisYearData.length > 0
      ? thisYearData.map((item) =>
          displayType === "cost" ? item.earned : item.generation,
        )
      : [];

  return thisYearSpendConsumptionTotals.length &&
    thisYearEarnedGenerationTotals.length
    ? Math.ceil(
        1.1 *
          Math.max(
            ...thisYearSpendConsumptionTotals,
            ...thisYearEarnedGenerationTotals,
          ),
      )
    : 0;
};

/**
 * @description Generate the configuration for the grouped bar chart
 */

export const generateSolarGroupedBarChartConfig = ({
  thisYearData,
  displayType = "cost",
}): GroupedBarChartConfig => ({
  labels: createMonthLabels(),
  dates: thisYearData.map((data: MonthlyData) => data.month),
  yAxisText: Y_AXIS_DISPLAY_TYPE[displayType],
  chartTitle: "Monthly usage",
  datasets: [
    {
      label: "Sold",
      data:
        displayType === "cost"
          ? createDataArray(thisYearData, "earned")
          : createDataArray(thisYearData, "generation"),
      status: "pending",
      barColour: BRAND_COLOURS.green,
      hoverBackgroundColour: BRAND_COLOURS.greenDark,
    },
    {
      label: "Bought",
      data:
        displayType === "cost"
          ? createDataArray(thisYearData, "spend")
          : createDataArray(thisYearData, "consumption"),
      status: "pending",
      barColour: BRAND_COLOURS.yellow,
      hoverBackgroundColour: BRAND_COLOURS.yellowDark,
    },
  ],
  showZoom: true,
});
